const webMobile = [
  { id: 1, name: "React", image: "svg/react-logo.svg" },
  { id: 2, name: "NextJS", image: "svg/nextjs-logo.svg" },
  { id: 3, name: "NodeJS", image: "svg/node-logo.svg" },
  { id: 4, name: "Flutter", image: "svg/flutter-logo.svg" },
  { id: 5, name: "Kotlin", image: "svg/kotlin-logo.svg" },
  { id: 6, name: "MongoDB", image: "svg/mongo-logo.svg" },
  { id: 7, name: "Tailwind", image: "svg/tailwind-logo.svg" },
  { id: 8, name: "SASS", image: "svg/sass-logo.svg" },
  { id: 9, name: "TypeScript", image: "svg/ts-logo.svg" },
  { id: 10, name: "PHP", image: "svg/php-logo.svg" },
  { id: 11, name: "Wordpress", image: "svg/wp-logo.svg" },
  { id: 12, name: "Vanilla", image: "svg/js-logo.svg" },
];

export default webMobile;
